export default function(instance){
    return{
        GetAll(){
            return instance.get('/Brand/GetAll');
        },
    }
}
